import React from 'react';

import CabecalhoGraficoMobile from 'components/Windx/Mobile/CabecalhoGrafico';
import TabelaComparativoSM from 'components/Windx/TabelaComparativoSM';

import './index.scss';

/**
 * Comparativo SM no mobile (spec Windx mobile, Task 13 / D7).
 *
 * A tabela e a MESMA do desktop, atras da prop opcional `modoMobile`: a
 * grade larga com todas as entidades e o mesmo pin de coluna congelada.
 * A unica diferenca e um botao de tela cheia (paisagem) a mais na toolbar
 * — a tabela e ampla demais para o retrato do celular. Query, calculo de
 * cor e comparacao vertical seguem dentro do componente — nada foi extraido.
 *
 * `permiteSelecaoVazia` porque aqui o backend trata `id_entidades=[]` como
 * "todas" — regra que vem do desktop. O download nao aparece nesta tela: o
 * botao mora na barra de topo e o `WindxWrapper` o omite no Comparativo,
 * que nao tem ZIP.
 */
export default function ComparativoMobile() {
  return (
    <div className="windx-comparativo-mobile" data-testid="windx-comparativo-mobile">
      <CabecalhoGraficoMobile tela="sm" permiteSelecaoVazia>
        <TabelaComparativoSM modoMobile />
      </CabecalhoGraficoMobile>
    </div>
  );
}
